<template>
    <picture>
        <source :srcset="bannerImage.mobile" media="(max-width: 767px)" />
        <img :src="bannerImage.desktop" alt="" id="banner-avaliacoes-home" />
    </picture>
</template>

<script>
    export default {
        name: 'BannerAvaliacoesHome',
        props: {
            avaliation: {
                type: Object,
            },
        },

        data() {
            return {};
        },

        computed: {
            ratingProgress() {
                if (!this.avaliation) {
                    return null;
                }

                const notRatedProducts = this.avaliation.products.filter(
                    (product) => product.note === null
                ).length;

                return {
                    allPending: notRatedProducts === this.avaliation.products.length,
                    somePending:
                        notRatedProducts !== 0 &&
                        notRatedProducts !== this.avaliation.products.length,
                    nonePending: notRatedProducts === 0,
                };
            },

            bannerImage() {
                if (!this.ratingProgress || this.ratingProgress.allPending) {
                    return {
                        desktop: `${this.$scope.CDN_IMAGES}/images/hotsites/avaliacoes/banner-hora-de-avaliar-736.png?auto=compress,format&q=65`,
                        mobile: `${this.$scope.CDN_IMAGES}/images/hotsites/avaliacoes/banner-hora-de-avaliar-384.png?auto=compress,format&q=65`,
                    };
                } else if (this.ratingProgress.somePending) {
                    return {
                        desktop: `${this.$scope.CDN_IMAGES}/images/hotsites/avaliacoes/banner-siga-avaliando-736.png?auto=compress,format&q=65`,
                        mobile: `${this.$scope.CDN_IMAGES}/images/hotsites/avaliacoes/banner-siga-avaliando-384.png?auto=compress,format&q=65`,
                    };
                } else if (this.ratingProgress.nonePending) {
                    return {
                        desktop: `${this.$scope.CDN_IMAGES}/images/hotsites/avaliacoes/banner-avaliacoes-concluidas-736.png?auto=compress,format&q=65`,
                        mobile: `${this.$scope.CDN_IMAGES}/images/hotsites/avaliacoes/banner-avaliacoes-concluidas-384.png?auto=compress,format&q=65`,
                    };
                }
            },
        },

        methods: {},
    };
</script>
